/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/**
 * Init Team 404 slider
 */
if (document.querySelectorAll('.team-slider').length) {

  var teamSlider = tns({
    container             : '.team-slider',
    items                 : 1,
    controls              : false,
    navContainer          : '.team-slider__nav',
    autoplay              : true,
    autoplayTimeout       : 3000,
    autoplayButtonOutput  : false,
  });

}

/**
 * Init Numbers slider
 */
if (document.querySelectorAll('.section-numbers__carousel').length) {

  var numbersSlider = tns({
    container             : '.section-numbers__carousel',
    items                 : 1,
    axis                  : 'vertical',
    controls              : false,
    navPosition           : 'bottom',
    autoplay              : true,
    autoplayTimeout       : 3000,
    autoplayButtonOutput  : false,
  });

}

/**
 * Smooth scroll for anchor links menu if exist
 */

if (document.querySelectorAll('.menu-item--scroll').length) {

  // tasks to close menu visually
  var close_menu = function() {

    document.body.classList.add('is-closing-menu');
    setTimeout(function(){
      document.body.classList.remove('is-active-menu');
      document.body.classList.remove('is-closing-menu');
     }, 200);

  };

  document
      .querySelectorAll('.menu-item--scroll a[href^="#"]')
      .forEach(trigger => {
          trigger.onclick = function(e) {
              e.preventDefault();
              let hash = this.getAttribute('href');
              let target = document.querySelector(hash);
              let headerOffset = 100;
              let elementPosition = target.offsetTop;
              let offsetPosition = elementPosition - headerOffset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              });

              /* Check if menu is mobile active, then simulate click for closing him (bescause mobile menu cover all the window) */
              if (document.body.classList.contains('is-active-menu')) {

                var mobileNav = document.querySelectorAll(".mobile-menu__nav");
                var toggle = mobileNav[0].querySelector('.js-menu-toggle');

                if (toggle.onclick) {
                   toggle.onclick();
                } else if (toggle.click) {
                   toggle.click();
                }

              }

          };
      });

}
